import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const ADMIN_PW_STORAGE_KEY = "fd_admin_pw";

export const getAdminPw = () => localStorage.getItem(ADMIN_PW_STORAGE_KEY) || "";
export const setAdminPw = (pw) => localStorage.setItem(ADMIN_PW_STORAGE_KEY, pw);
export const clearAdminPw = () => localStorage.removeItem(ADMIN_PW_STORAGE_KEY);

export const adminHeaders = () => ({ "X-Admin-Password": getAdminPw() });
